import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
import React from "react";

const ReportsAssignmentsLogList = lazyLoader(
  () =>
    import(
      "Containers/Reports/ReportsInnerPages/ReportsAssignmentsLog/ReportsAssignmentsLogList/ReportsAssignmentsLogList"
    )
);
export const ReportsAssignmentsLog = () => {
  return (
    <Layout>
      <ReportsAssignmentsLogList />
    </Layout>
  );
};
